module.exports = __webpack_public_path__ + "static/IMG-2-19490a7d9d826b07f5aa0e0dd5d29c43.jpg";